angular.module('bbl.module.line-settings', [
	'bbl.services',
	'bbl.module.line-settings.routing',
	'bbl.module.line-settings.controller',
]);

require('./line-settings.style.less');
require('./line-settings.routing');
require('./line-settings.controller');
require('./upload-directive/upload.directive');



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/line-settings/line-settings.module.js
 ** module id = 345
 ** module chunks = 0
 **/